import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type SierraChildDeviceUpdateEndpointSpecification = ApiEndpointSpecification;
export const SierraChildDeviceUpdateEndpointSpecification: SierraChildDeviceUpdateEndpointSpecification = {
    url: '/api/sierradevice/childdevice',
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'SierraChildDeviceUpdateRequestParams',
    requestBodySchemaName: 'SierraChildDeviceUpdateRequestBody',
    okResponseSchemaName: 'SierraChildDeviceUpdateOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 1
};

export const invokeSierraChildDeviceUpdate = Helpers.makeApiRequestFn<
    Types.SierraChildDeviceUpdateRequestParams,
    Types.SierraChildDeviceUpdateRequestBody,
    Types.SierraChildDeviceUpdateOkResponse
>(SierraChildDeviceUpdateEndpointSpecification);
